export const xStoreId = () => {
  return localStorage.getItem('x-store-id')
}
